import { Button } from '@statsbomb/kitbag-components';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { isDisabledContinueButtonAtom, radarTemplateModalActiveStepAtom } from '@/atoms/radar';

export const ContinueButton = () => {
  const { t } = useTranslation('general');
  const [activeStep, setActiveStep] = useAtom(radarTemplateModalActiveStepAtom);
  const isDisabledContinueButton = useAtomValue(isDisabledContinueButtonAtom);

  const onClick = () => setActiveStep(activeStep + 1);

  return (
    <Button onClick={onClick} variant="primary" disabled={isDisabledContinueButton}>
      {t('continue', { ns: 'general' })}
    </Button>
  );
};
